import modelTransformer from './modelTransformer';

const protocol = 'https:';

const defaults = {
    expires: 30,
    timeout: 30,
    namespace: '{gamePk}',
    mimetype: 'application/json',
    domain: protocol + '//statsapi.mlb.com/',
    transformer: modelTransformer,
    env: {
        local: {
            domain: protocol + '//statsapi.mlb.com/'
        },
        dev: {
            domain: protocol + '//statsapi.mlb.com/'
        },
        qa: {
            domain: protocol + '//qa-statsapi.mlb.com/'
        },
        beta: {
            domain: protocol + '//statsapi.mlb.com/'
        },
        prod: {
            domain: protocol + '//statsapi.mlb.com/'
        }
    }
};

const wsStatsApiDefaults = {
    domain: 'https://ws.statsapi.mlb.com/',
    env: {
        local: {
            domain: 'https://ws.statsapi.mlb.com/'
        },
        dev: {
            domain: 'https://ws.statsapi.mlb.com/'
        },
        qa: {
            domain: 'https://ws.qa-statsapi.mlb.com/'
        },
        beta: {
            domain: 'https://ws.statsapi.mlb.com/'
        },
        prod: {
            domain: 'https://ws.statsapi.mlb.com/'
        }
    }
};

const socketDefaults = {
    domain: 'wss://ws.statsapi.mlb.com/',
    env: {
        local: {
            domain: 'wss://ws.statsapi.mlb.com/'
        },
        dev: {
            domain: 'wss://ws.statsapi.mlb.com/'
        },
        qa: {
            domain: 'wss://ws.qa-statsapi.mlb.com/'
        },
        beta: {
            domain: 'wss://ws.statsapi.mlb.com/'
        },
        prod: {
            domain: 'wss://ws.statsapi.mlb.com/'
        }
    }
};

// TODO: update to use prod stitch in correct envs once available
const stitchDefaults = {
    domain: protocol + '//bdfed.stitch.mlbinfra.com/',
    env: {
        local: {
            domain: protocol + '//bdfed.stitch.npd.mlbinfra.com/'
        },
        dev: {
            domain: protocol + '//bdfed.stitch.npd.mlbinfra.com/'
        },
        qa: {
            domain: protocol + '//bdfed.stitch.npd.mlbinfra.com/'
        },
        beta: {
            domain: protocol + '//bdfed.stitch.mlbinfra.com/'
        },
        prod: {
            domain: protocol + '//bdfed.stitch.mlbinfra.com/'
        }
    }
};

const dapiDefaults = {
    domain: protocol + '//dapi.cms.mlbinfra.com/v2/content/',
    env: {
        local: {
            domain: protocol + '//dapi.cms.mlbinfra.com/v2/content/'
        },
        dev: {
            domain: protocol + '//dapi.cms.mlbinfra.com/v2/content/'
        },
        qa: {
            domain: protocol + '//dapi.cms.mlbinfra.com/v2/content/'
        },
        beta: {
            domain: protocol + '//dapi.cms.mlbinfra.com/v2/content/'
        },
        prod: {
            domain: protocol + '//dapi.cms.mlbinfra.com/v2/content/'
        }
    }
};

const entitlementsDefaults = {
    domain: protocol + '//mlbentitlementservices.mlb.com/entitlements',
    env: {
        local: {
            domain: protocol + '//mlbentitlementservices.commerce-dev.mlbinfra.com/entitlements'
        },
        dev: {
            domain: protocol + '//mlbentitlementservices.commerce-dev.mlbinfra.com/entitlements'
        },
        qa: {
            domain: protocol + '//mlbentitlementservices.commerce-dev.mlbinfra.com/entitlements'
        },
        beta: {
            domain: protocol + '//mlbentitlementservices.mlb.com/entitlements'
        },
        prod: {
            domain: protocol + '//mlbentitlementservices.mlb.com/entitlements'
        }
    }
};

const midfieldDefaults = {
    domain: protocol + '//data-graph.mlb.com/',
    headers: {
        'Content-Type': 'application/json',
        'Apollographql-Client-Name': 'gameday-{env:prod}',
        'Apollographql-Client-Version': 'v0.0.0'
    },
    env: {
        local: {
            domain: protocol + '//data-graph.mlb.com/'
        },
        dev: {
            domain: protocol + '//data-graph.mlb.com/'
        },
        qa: {
            domain: protocol + '//data-graph.mlb.com/'
        },
        beta: {
            domain: protocol + '//data-graph.mlb.com/'
        },
        prod: {
            domain: protocol + '//data-graph.mlb.com/'
        }
    },
    supportedLocales: new Map([['en-US', 'EN_US'], ['es-US', 'ES_US'], ['ja-JP', 'JA_JP']]),
    contentSource: {
        mlb: 'MLB',
        milb: 'MILB'
    }
};

const mlbBaseDefaults = {
    domain: 'https://www.mlb.com/',
    env: {
        local: {
            domain: 'https://www.mlb.com/'
        },
        dev: {
            domain: 'https://www.mlb.com/'
        },
        qa: {
            domain: 'https://www.mlb.com/'
        },
        beta: {
            domain: 'https://www.mlb.com/'
        },
        prod: {
            domain: 'https://www.mlb.com/'
        }
    }
};

const fastballGatewayDefaults = {
    domain: protocol + '//fastball-gateway.mlb.com/',
    headers: {
        'Content-Type': 'application/json'
    },
    env: {
        local: {
            domain: protocol + '//fastball-gateway.mlb.com/'
        },
        dev: {
            domain: protocol + '//fastball-gateway.mlb.com/'
        },
        qa: {
            domain: protocol + '//fastball-gateway.mlb.com/'
        },
        beta: {
            domain: protocol + '//fastball-gateway.mlb.com/'
        },
        prod: {
            domain: protocol + '//fastball-gateway.mlb.com/'
        }
    }
};

export {
    defaults,
    socketDefaults,
    wsStatsApiDefaults,
    stitchDefaults,
    dapiDefaults,
    entitlementsDefaults,
    midfieldDefaults,
    mlbBaseDefaults,
    fastballGatewayDefaults
};
